"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 17.86C6.8 16.09 9.27 15 12 15s5.2 1.09 7 2.86V5H5zM12 6c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 16H7v-.24C8.42 17.62 10.16 17 12 17s3.58.62 5 1.76zm2-1.14C17.2 16.09 14.73 15 12 15s-5.2 1.09-7 2.86V5h14z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M12 13c1.93 0 3.5-1.57 3.5-3.5S13.93 6 12 6 8.5 7.57 8.5 9.5 10.07 13 12 13m0-5c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8"
}, "2")], 'AccountBoxTwoTone');